// @flow

import './index.scss';
import * as React from 'react';
import classnames from 'classnames';
import { useTranslate } from '@insolus/react-i18n';
import { Button } from '@insolus/ui-kit';
import SearchForm from '../../components/SearchForm';
import extractUrlCriteria from 'utils/extractUrlCriteria';
import staticRedirect from 'utils/staticRedirect';
import formatUrlCriteria from 'utils/formatUrlCriteria';

import type { SearchFormData } from '../../components/SearchForm';

const SearchElement = (): React.Node => {
    const {
        categoryId,
        manufacturerId,
        adConditionId,
        onlyRental,
        min,
        max,
        advertiserId
    } = extractUrlCriteria(window.location.href);

    const hasCriteria = categoryId || manufacturerId || adConditionId || advertiserId || min || max;

    const { __ } = useTranslate();
    const [open, setOpen] = React.useState<boolean>(!hasCriteria);

    React.useEffect(() => {
        setOpen(!categoryId && !manufacturerId && !adConditionId && !advertiserId && !min && !max);
    }, [categoryId, manufacturerId, adConditionId, advertiserId, min, max]);

    const handleSearch = React.useCallback((formData: SearchFormData) => {
        const searchPath = formatUrlCriteria({ ...formData });

        // $FlowFixMe Turbolinks est chargé à l'extérieur
        if (Turbolinks) { // eslint-disable-line no-undef
            Turbolinks.visit(searchPath); // eslint-disable-line no-undef
        } else {
            staticRedirect(searchPath);
        }
    }, []);

    const handleToggle = React.useCallback(() => {
        setOpen(prev => !prev);
    }, []);

    return (
        <div
            className={classnames(
                'Search',
                {
                    'Search--open'  : open,
                    'Search--fixed' : !hasCriteria
                }
            )}
        >
            <SearchForm
                categoryId={categoryId}
                manufacturerId={manufacturerId}
                adConditionId={adConditionId}
                onlyRental={onlyRental}
                priceRange={{ min: 0, max: 100000 }}
                defaultPrices={{ min: 0, max: 100000 }}
                onSearch={handleSearch}
            />
            <div className="Search__drawer">
                <Button onClick={handleToggle}>
                    {open ? __('close-search') : __('modify-search')}
                </Button>
            </div>
        </div>
    );
};

export default SearchElement;
